import React, { useMemo } from 'react';
import VoxelAutocomplete, { VoxelAutocompleteProps } from '../../voxel/Forms/VoxelAutocomplete';
import { CurrencyOptionGq } from '../../../graphql/projects/models/CurrencyOptionGq';
import { currencyList } from '../../../graphql/projects/models/Currencies';

export interface VoxelAutocompleteCurrencyProps
  extends Omit<
    VoxelAutocompleteProps,
    'setSelectedOptions' | 'options' | 'selectedOptionValues' | 'fixedOptions' | 'freeAdd' | 'multi'
  > {
  selectedCurrency?: Partial<CurrencyOptionGq>;
  setSelectedCurrency: (value?: Partial<CurrencyOptionGq>) => void;
}

export const VoxelAutocompleteCurrency: React.FC<VoxelAutocompleteCurrencyProps> = ({
  label,
  labelPosition,
  placeholder,
  selectedCurrency,
  setSelectedCurrency,
  ...forwardedProps
}) => {
  const currencyOptions = useMemo(
    () => currencyList.map((currency) => ({ value: currency.code, title: currency.name })),
    [currencyList]
  );

  const selectedOptionValues = useMemo(() => [selectedCurrency.code], [selectedCurrency]);

  return (
    <VoxelAutocomplete
      emptyAllowed={false}
      {...forwardedProps}
      id="location"
      label={label ?? 'Currency'}
      labelPosition={labelPosition ?? 'left'}
      placeholder={placeholder ?? 'N/A'}
      selectedOptionValues={selectedOptionValues}
      options={currencyOptions}
      setSelectedOptions={(options) => {
        const selectedOption = options[0];
        const currency = currencyList.find((currency) => currency.code === selectedOption?.value);
        setSelectedCurrency(currency);
      }}
    />
  );
};

export default VoxelAutocompleteCurrency;
